module.exports = __webpack_public_path__ + "img/vbet_03.2c68c6dc.jpg";